import { Helmet } from "react-helmet-async";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

export interface FAQ {
  q: string;
  a: string;
}

interface Props {
  title?: string;
  subtitle?: string;
  items: FAQ[];
}

export const FAQSection = ({ title = "Domande frequenti", subtitle, items }: Props) => {
  const jsonLd = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: items.map((i) => ({
      "@type": "Question",
      name: i.q,
      acceptedAnswer: { "@type": "Answer", text: i.a },
    })),
  };

  return (
    <section className="section-padding bg-subtle">
      <Helmet>
        <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>
      </Helmet>
      <div className="container max-w-3xl">
        <div className="text-center mb-10">
          <p className="uppercase tracking-widest text-secondary text-xs font-bold mb-3">FAQ</p>
          <h2 className="heading-lg text-primary">{title}</h2>
          {subtitle && <p className="text-muted-foreground mt-3">{subtitle}</p>}
        </div>
        <Accordion type="single" collapsible className="bg-card rounded-lg shadow-soft border border-border px-6">
          {items.map((it, i) => (
            <AccordionItem key={i} value={`faq-${i}`}>
              <AccordionTrigger className="text-left font-semibold text-primary">
                {it.q}
              </AccordionTrigger>
              <AccordionContent className="text-muted-foreground leading-relaxed">
                {it.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
};
